export const configOCBaseDh = {
  "Controller": {
    "Name": "EXPO_NumericalDB",
    "data": "WNI_LRF_CRRNT_GLOBAL",
    "tile_size":256
  },
  "Source": {
    "basetime": {
      "Type":"JSON",
      "url" : "%numerical_db_gpv_url%/%data%/basetimes",
      "validtimes": 1,
      "retain": true,
      "cache_busting": "YYYYMMDDhhmm",
      "_cache_busting": true
    },
    "validtime": {
      "Type":"JSON",
      "url" : "%numerical_db_gpv_url%/%data%/valid_times?basetime=%basetime%",
      "retain": true,
      "cache": true
    },
    "region": {
      "Type":"JSON",
      "url" : "%numerical_db_gpv_url%/%data%/area_info",
      "retain": true,
      "cache": true
    },
    "level": {
      "Type":"JSON",
      "url" : "%numerical_db_gpv_url%/%data%/levels",
      "retain": true,
      "cache": true
    },
    "element": {
      "Type":"JSON",
      "url" : "%numerical_db_gpv_url%/%data%/detailed_elements",
      "retain": true,
      "cache": true
    },
    "data": {
      "Type": "Binary",
      "url" : "%numerical_db_gpv_url%/%data%/stride",
      "_min_precision":1.0, 
      "post_data": "{\"basetime\":\"%basetime%\",\"valid_time\":[\"%validtime%\"],\"elements\":[\"%element%\"],\"levels\" :[\"%level%\"],\"start_IGRID\" :%sx%,\"start_JGRID\":%sy%,\"end_IGRID\":%ex%,\"end_JGRID\":%ey%,\"stride_IGRID\":%dx%,\"stride_JGRID\":%dy%}",
      "alias": {
        "element":{
          "TMP":"AIRTMP",
          "RH":"RHUM"
        },
        "level":{
          "000":"0"
        }
      },
      "_Grid": {
        "element": {
          "SOLRAD": {
          "MinValue": 0
        }
      }
    },
      "cache": true
    },
    "timelist": {
      "Type":"Derived",
      "retain": true,
      "update_interval": 600,
      "_update_interval": 3600
    }
  }
};

export const configOCSpeedDirectionConverterDh = {
  "Controller": {
    "Name": "SpeedDirectionConverter",
    "UElement": "UCRRNT",
    "VElement": "VCRRNT",
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "retain": true,
      "reference": configOCBaseDh,
    },
    "level": {
      "Type": "JSON",
      "retain": true,
      "reference": configOCBaseDh,
    },
    "data": {
      "Type": "Derived",
      "reference": configOCBaseDh,
    },
  },
};

export const configCurrentLayerArrow = {
  "Name" : "CurrentGridArrow",
  "Renderer" : "GridArrow",
  "Attributes" : {
    "_data_scale" : 1.94384,
    "_data_offset" : 0,
    "_threshold" : 0,
    "cross_fade": 0.4,
    "style" : {
      "default" : {
        "min_blocksize": 10,
        "overlap_range": 20,
        "base_length" : 10,
        "speed_length_racio" : 10,
        "palette_gradient": true,
        "palette_step": 0.05,
        "palette" : [
          {
            "value" : 0.1,
            "color" : "rgba(32,128,255,0.0)"
          },
          {
            "value" : 0.25,
            "color" : "rgba(32,128,255,0.5)"
          },
          {
            "value" : 0.5,
            "color" : "rgba(32,200,255,0.7)"
          },
          {
            "value" : 0.75,
            "color" : "rgba(48,255,255,0.8)"
          },
          {
            "value" : 1.0,
            "color" : "rgba(48,255,48,0.8)"
          },
          {
            "value" : 1.25,
            "color" : "rgba(255,255,48,0.9)"
          },
          {
            "value" : 1.5,
            "color" : "rgba(255,48,48,0.9)"
          }
        ]
      }
    }
  }
};

export const configCurrentLayerStream = {
  "Name": "CurrentStreamLine",
  "Renderer": "StreamLine",
  "Attributes": {
    "data_scale" : 2,
    "min": 0.1,
    "scale": 0.05,
    "times": 100,
    "lines": 5000,
    "duration": 10,
    "separation": 8,
    "display": 1.0,
    "style": {
      "default" : {
        "palette" : [
          {
            "value" : 0.0,
            "color" : "rgba(255,255,255,0.8)"
          }
        ]
      }
    }
  }
};

export const configCurrentLayerGradation = {
  "Name" : "CurrentIsotach",
  "Renderer" : "Mesh",
  "Attributes" : {
    "_data_scale": 1.94552529,
    "data_scale": 10,
    "style" : {
      "default": {
        "fill_type" : "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette" : [
          {
            "value" : 0,
            "color" : "rgba(98,113,183,0.7)"
          },
          {
            "value" : 1,
            "color" : "rgba(57,97,159,0.7)"
          },
          {
            "value" : 3,
            "color" : "rgba(74,148,169,0.7)"
          },
          {
            "value" : 5,
            "color" : "rgba(77,141,123,0.7)"
          },
          {
            "value" : 7,
            "color" : "rgba(83,165,83,0.7)"
          },
          {
            "value" : 9,
            "color" : "rgba(53,159,53,0.7)"
          },
          {
            "value" : 11,
            "color" : "rgba(167,157,81,0.7)"
          },
          {
            "value" : 13,
            "color" : "rgba(159,127,58,0.7)"
          },
          {
            "value" : 15,
            "color" : "rgba(161,108,92,0.7)"
          },
          {
            "value" : 17,
            "color" : "rgba(129,58,78,0.7)"
          },
          {
            "value" : 19,
            "color" : "rgba(175,80,136,0.7)"
          },
          {
            "value" : 21,
            "color" : "rgba(117,74,147,0.7)"
          },
          {
            "value" : 24,
            "color" : "rgba(109,97,163,0.7)"
          },
          {
            "value" : 27,
            "color" : "rgba(68,105,141,0.7)"
          },
          {
            "value" : 29,
            "color" : "rgba(92,144,152,0.7)"
          },
          {
            "value" : 36,
            "color" : "rgba(125,68,165,0.7)"
          },
          {
            "value" : 46,
            "color" : "rgba(231,215,215,0.7)"
          },
          {
            "value" : 51,
            "color" : "rgba(219,212,135,0.7)"
          },
          {
            "value" : 77,
            "color" : "rgba(205,202,112,0.7)"
          },
          {
            "value" : 104,
            "color" : "rgba(128,128,128,0.7)"
          }
        ]
      }
    }
  }
};

export const configCurrentLayerGrid = {
  "Name" : "CurrentGridValue",
  "Renderer": "GridValueExt",
  "Attributes": {
    "_data_offset": -273.15,
    "cross_fade": 0.7,
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 60,
        "fractional_digits": 1,
        "color": "rgba(0, 0, 0, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      },
      "dark": {
        "min_blocksize": 40,
        "overlap_range": 60,
        "fractional_digits": 1,
        "color": "rgba(255, 255, 255, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      }
    }
  }
};
